module.exports = __webpack_public_path__ + "static/media/edit_section_fields_video.39defb26.mov";